import {FileTSStatusStatistic, StatusCodeE} from "../../model/models";
import "./Cruscotto.css";
import {useTranslation} from "react-i18next";

interface StatusCardListProps {
    statistics: FileTSStatusStatistic[],
    selectedStatus: StatusCodeE | null,
    handleStatusClick: (statusCode: StatusCodeE) => void
}

export default function StatusCardList({statistics, selectedStatus, handleStatusClick}: StatusCardListProps) {
    const {t} = useTranslation();
    const attesaFirmaStatistic = statistics
        .filter(s => s.codStatus === StatusCodeE.ATTESA_FIRMA);

    const attesaFirmaCount = attesaFirmaStatistic && attesaFirmaStatistic[0] ? attesaFirmaStatistic[0].count : 0;

    return (
        <div className="cruscotto-container">
            {statistics
                .filter((s) => (s.codStatus !== StatusCodeE.ATTESA_FIRMA && s.codStatus !== StatusCodeE.ATTESA_PAGOPA && s.codStatus !== StatusCodeE.ESCLUSO_DA_RICALCOLO))
                .map((s) => {
                    const isSelected = selectedStatus === s.codStatus;
                    const isDisabled = s.codStatus === StatusCodeE.DA_FIRMARE ? (s.count + attesaFirmaCount) === 0 : s.count === 0;

                    return (
                        <div
                            key={s.codStatus}
                            className={`status-card ${isSelected ? "active" : ""}`}
                            style={{
                                backgroundColor: isSelected
                                    ? "rgb(0, 122, 51)"
                                    : isDisabled
                                        ? "#f0f0f0"
                                        : "transparent",
                                color: isSelected ? "white" : isDisabled ? "#aaa" : "black",
                            }}
                            onClick={() => {
                                if (!isSelected && !isDisabled) {
                                    handleStatusClick(s.codStatus);
                                }
                            }}
                        >
                            <span className="status-title">{t(s.codStatus)}</span>
                            <span
                                className="status-count"
                                style={{color: isSelected ? "white" : isDisabled ? "#ccc" : "green"}}
                            >
                                {s.codStatus === StatusCodeE.DA_FIRMARE ? s.count + attesaFirmaCount : s.count}
                            </span>
                        </div>
                    );
                })}
        </div>
    );
}
